import defaultValues from "@/constant/defaultValues";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import { useRef, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import {
  ClassicEditor,
  Essentials,
  Bold,
  Italic,
  Underline,
  FontSize,
  Paragraph,
  List,
} from "ckeditor5";
import ReCAPTCHA from "react-google-recaptcha";
import Button from "@/components/Button";
import { useDispatch, useSelector } from "react-redux";
import regExpressions from "@/constant/regExpressions";
import errorMessages from "@/constant/errorMessages";
import { cloneDeep, filter, isArray, isEmpty, lowerCase, map, size, trim } from "lodash";
import { selectFormattedCountries } from "@/store/modern/slices/countrySlice";
import {
  fetchAllPorts,
  fetchCountryPorts,
  selectFormattedDestinationCountryPorts,
  selectFormattedOriginCountryPorts,
} from "@/store/modern/slices/portSlice";
import { postInquiryQuote } from "@/store/modern/slices/inquirySlice";
import { showSuccessMessage } from "@/utils/common";
import ScreenLoaderHome from "@/components/common/ScreenLoaderHome";
import { motion } from "framer-motion";
import { useAuth } from "@/AuthProvider";
import wordImg from "@/images/word.webp";
import excelImg from "@/images/excel.webp";
import attachmentImg from "@/assets/images/svg/attachment-img.svg";
import pdfsvgImg from "@/assets/images/svg/pdf-img.svg";
import RoadFreight from "./Logistics/RoadFreight";
import AirFreight from "./Logistics/AirFreight";
import DAPFreight from "./Logistics/DAPFreight";
import { isValid } from "date-fns";
import SeaFreight from "./Logistics/SeaFreight";

const LogisticInqForm = () => {
  const {
    TERM_LIST,
    OCEAN_TYPE,
    FREIGHT_TYPE,
    EMAIL_FIELD_MAX_LENGTH,
    IGNORE_EMAILS,
  } = defaultValues;

  const ALLOWED_TYPES = [
    "image/jpeg",
    "image/jpg",
    "image/png",
    "image/webp",
    "application/pdf",
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "application/vnd.ms-excel", // .xls
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "text/csv",
  ];

  const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB

  const FILE_SLOTS = ["attechment#@FILE1", "attechment#@FILE2"];

  const showPickupAddress = [
    "EXW (Ex-Works or Ex-Warehouse)",
    "FCA (Free to Carrier)",
  ];
  const showDeliveryAddress = [
    "CPT (Carriage Paid To)",
    "CIP (Carriage And Insurance Paid To)",
    "DAP (Delivered At Place)",
    "DDP (Delivered Duty Paid)",
  ];

  const recaptcha = useRef();
  const fileInputsRef = useRef(new Map());

  const dispatch = useDispatch();
  const countries = useSelector(selectFormattedCountries);
  const cPorts = useSelector(selectFormattedOriginCountryPorts);
  const dPorts = useSelector(selectFormattedDestinationCountryPorts);

  const { user } = useAuth();

  const inputFields = {
    company_name: user ? user.company_name : "",
    contact_person: user ? user.name : "",
    email: user ? user.email : "",
    phone: "",
    message: "",
    country_from: "",
    country_from_id: "",
    country_to: "",
    country_to_id: "",
    freight_type: "",
    port_of_destination: "",
    port_of_origin: "",
    ocean_type: "",
    lwh: "",
    cbpp: "",
    total_weight: "",
    term: "",
    pickup_address: "",
    delivery_address: "",
    no_of_containers: "",
    type: "Logistic_Partner",
    commodity: "",
    inquiry_type: "GLOBAL",
    created_by: user ? user.id : null,
    no_qty: null,
    hs_code: "",
    lwh_qty_packaging: [
      {
        lwh: " ",
        no_qty: " ",
        cbpp: " ",
      },
    ],
  };

  const [formData, setFormData] = useState(inputFields);
  const [phoneValue, setphoneValue] = useState("");
  const [errors, setErrors] = useState({});
  const [recaptchaValue, setRecapchaValue] = useState(null);
  const [isButtonDisabled, setisButtonDisabled] = useState(false);

  const [previewUrls, setPreviewUrls] = useState({});

  const [selectedFreightType, setSelectedFreightType] = useState(null);
  const [selectedPortOfOrigin, setSelectedPortOfOrigin] = useState(null);
  const [selectedPortOfDestination, setSelectedPortOfDestination] =
    useState(null);
  const [portLabel, setPortLabel] = useState("Port");
  const [selectedCountryFrom, setSelectedCountryFrom] = useState(null);
  const [selectedCountryTo, setSelectedCountryTo] = useState(null);
  const [selectedCbpp, setSelectedCbpp] = useState(null);

  const [selectedOceanType, setSelectedOceanType] = useState(null);

  const [portOfOriginList, setPortOfOriginList] = useState([]);
  const [portOfDestinationList, setPortOfDestinationList] = useState([]);

  const [originLoader, setOriginLoader] = useState(false);
  const [destinationLoader, setDestinationLoader] = useState(false);

  const [selectedTerm, setSelectedTerm] = useState(null);
  const [isLoading, setLoading] = useState(false);

  const handlePhoneChange = (val) => {
    setphoneValue(val);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        phone: val,
      };
    });
  };

  const handleFreightTypeChange = (cval) => {
    const freightTypeId = cval.value;
    setSelectedFreightType(cval);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        freight_type: freightTypeId,
        port_of_origin: "",
        port_of_destination: "",
        isNewValOrigin: false,
        isNewValDestination: false,
        ocean_type: null
      };
    });

    setSelectedOceanType(null);

    setSelectedPortOfOrigin(null);
    setSelectedPortOfDestination(null);

    if (cval.value === "Air") {
      setPortLabel("Air");
    } else {
      setPortLabel("Port");
    }

    let errObj = { ...errors };

    errObj[`ocean_type`] = "";
    // errObj[`commodity`] = "";

    if (freightTypeId == "Road") {
      errObj[`country_from`] = "";
      errObj[`country_to`] = "";
      errObj[`no_of_containers`] = "";
      errObj[`lwh`] = "";
      errObj[`cbpp`] = "";
      errObj[`port_of_origin`] = "";
      errObj[`port_of_destination`] = "";
      errObj[`lwh_qty_packaging`] = [];
      errObj[`term`] = "";
    }

    setErrors(errObj);
  };

  const fetchCountryPortsWithType = async (reqObj) => {
    if (reqObj.type === "countryFrom") {
      setOriginLoader(true);
    } else if (reqObj.type === "countryTo") {
      setDestinationLoader(true);
    }

    try {
      const response = await dispatch(fetchCountryPorts(reqObj));
      if (response?.meta?.requestStatus === "fulfilled" && response.payload) {
        const options = map(response.payload.response, (val) => ({
          label: val.name,
          value: val.id,
        }));
        if (reqObj.type === "countryFrom") {
          setPortOfOriginList(options);
        } else if (reqObj.type === "countryTo") {
          setPortOfDestinationList(options);
        }
      }
    } finally {
      if (reqObj.type === "countryFrom") {
        setOriginLoader(false);
      } else if (reqObj.type === "countryTo") {
        setDestinationLoader(false);
      }
    }
  };

  const fetchCountryPortsWithAll = async (reqObj) => {
    if (reqObj.type === "origin_port") {
      setOriginLoader(true);
    } else if (reqObj.type === "destination_port") {
      setDestinationLoader(true);
    }
    try {
      const response = await dispatch(fetchAllPorts(reqObj));
      if (response?.meta?.requestStatus === "fulfilled" && response.payload) {
        const options = map(response.payload.response, (val) => ({
          label: val.name,
          value: val.id,
        }));
        if (reqObj.type === "origin_port") {
          setPortOfOriginList(options);
        } else if (reqObj.type === "destination_port") {
          setPortOfDestinationList(options);
        }
      }
    } finally {
      if (reqObj.type === "origin_port") {
        setOriginLoader(false);
      } else if (reqObj.type === "destination_port") {
        setDestinationLoader(false);
      }
    }
  };

  const handleCountryFromChange = (cval) => {
    const countryId = cval.value;
    const type = "countryFrom";
    setSelectedCountryFrom(cval);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        country_from: countryId,
        country_from_id: cval.countryId,
        port_of_origin: "",
        isNewValOrigin: false,
      };
    });
    setSelectedPortOfOrigin(null);
    if (selectedFreightType?.value !== "Air") {
      let reqObj = {
        countryID: cval.countryId,
        type: type,
      };
      if (countryId) {
        fetchCountryPortsWithType(reqObj);
      }
    }
  };

  const handleCountryToChange = (cval) => {
    const countryId = cval.value;
    const type = "countryTo";
    setSelectedCountryTo(cval);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        country_to: countryId,
        country_to_id: cval.countryId,
        port_of_destination: "",
        isNewValDestination: false,
      };
    });
    setSelectedPortOfDestination(null);
    if (selectedFreightType?.value !== "Air") {
      let reqObj = {
        countryID: cval.countryId,
        type: type,
      };
      if (countryId) {
        fetchCountryPortsWithType(reqObj);
      }
    }
  };

  const handleCbppTypeChange = (cbppVal) => {
    const cbpp_val = cbppVal.value;
    setSelectedCbpp(cbppVal);
    setFormData((prev) => {
      return {
        ...prev,
        cbpp: cbpp_val
      }
    })
  };

  const handlePortOfDestinationChange = async (val) => {
    if (val != null) {
      const portOfDestination = val.label;
      setSelectedPortOfDestination(val);
      setFormData((prevalue) => {
        return {
          ...prevalue,
          port_of_destination: portOfDestination,
          isNewValDestination: val.__isNew__ ? val.__isNew__ : false,
        };
      });
    }
  };

  const handleOriginPortInputChange = (val) => {
    if (val !== "") {
      if (val.length >= 3) {
        let reqObj = {
          offset: 0,
          limit: 10,
          search_txt: val,
          type: "origin_port",
        };
        fetchCountryPortsWithAll(reqObj);
      }
    } else {
      if (selectedFreightType?.value !== "Air") {
        const countryId = selectedCountryFrom?.countryId || "";
        if (countryId) {
          let reqObj = {
            countryID: countryId,
            type: "countryFrom",
          };
          fetchCountryPortsWithType(reqObj);
        } else {
          let reqObj = {
            offset: 0,
            limit: 10,
            search_txt: val,
            type: "origin_port",
          };
          fetchCountryPortsWithAll(reqObj);
        }
      }
    }
  };

  const handleDestinationPortInputChange = (val) => {
    if (val !== "") {
      if (val.length >= 3) {
        let reqObj = {
          offset: 0,
          limit: 10,
          search_txt: val,
          type: "destination_port",
        };
        fetchCountryPortsWithAll(reqObj);
      }
    } else {
      if (selectedFreightType?.value !== "Air") {
        const countryId = selectedCountryTo?.countryId || "";
        if (countryId) {
          let reqObj = {
            countryID: countryId,
            type: "countryTo",
          };
          fetchCountryPortsWithType(reqObj);
        } else {
          let reqObj = {
            offset: 0,
            limit: 10,
            search_txt: val,
            type: "destination_port",
          };
          fetchCountryPortsWithAll(reqObj);
        }
      }
    }
  };

  const handlePortOfOriginChange = async (val) => {
    if (val != null) {
      const portOfOrigin = val.label;
      setSelectedPortOfOrigin(val);
      setFormData((prevalue) => {
        return {
          ...prevalue,
          port_of_origin: portOfOrigin,
          isNewValOrigin: val.__isNew__ ? val.__isNew__ : false,
        };
      });
    }
  };

  const validatePortInput = (inputValue) => {
    if (inputValue === "") return null;

    const validPortRegex = regExpressions.port_name;
    let error = "";
    if (!validPortRegex.test(inputValue)) {
      error = errorMessages.IN_VALID_FIELD_FORMAT;
    }
    return error || null;
  };

  const handleOceanTypeChange = (cval) => {
    const oceanTypeId = cval.value;
    setSelectedOceanType(cval);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        ocean_type: oceanTypeId,
      };
    });
    // if (oceanTypeId === "Bulk") {
    //   setErrors((prev) => ({ ...prev, no_of_containers: "", cbpp: "" }));
    // }
    // if (oceanTypeId === "LCL") {
    //   setErrors((prev) => ({ ...prev, no_of_containers: "" }));
    // }

    if(formData.freight_type == "DAP") {
       if(oceanTypeId === "LCL") {
         setErrors((prev) => ({ ...prev, no_of_containers: "" }));
       }

       if(oceanTypeId === "Ro-Ro") {
         setErrors((prev) => ({ ...prev, no_of_containers: "" , cbpp: "" }));
       }

       if(oceanTypeId === "Project_Cargo") {
        setErrors((prev) => ({ ...prev, cbpp: "" }));
       }
    }

    if(formData.freight_type == "Ocean") {
      if(oceanTypeId === "LCL") {
         setErrors((prev) => ({ ...prev, no_of_containers: "" }));
       }

       if(oceanTypeId === "Ro-Ro") {
         setErrors((prev) => ({ ...prev, no_of_containers: "" , cbpp: "" }));
       }

       if(oceanTypeId === "Project_Cargo") {
        setErrors((prev) => ({ ...prev, cbpp: "" }));
       }

       if(oceanTypeId === "Bulk") {
         setErrors((prev) => ({ ...prev, no_of_containers: "" , cbpp: "" }));
       }
    }

  };

  const handleAddClick = () => {
    const blankRow = { lwh: " ", no_qty: " ", cbpp: " " };
    setFormData((prevData) => {
      return {
        ...prevData,
        lwh_qty_packaging: [
          ...(prevData.lwh_qty_packaging || []),
          { ...blankRow },
        ],
      };
    });
  };

  const handleRemoveClick = (indx) => {
    setFormData((prevData) => {
      return {
        ...prevData,
        lwh_qty_packaging: filter(
          prevData.lwh_qty_packaging,
          (_, index) => index != indx,
        ),
      };
    });
  };

  const handleTermChange = (cval) => {
    setErrors((prevalue) => {
      return {
        ...prevalue,
        pickup_address: "",
        delivery_address: "",
      };
    });

    const termId = cval.value;
    setSelectedTerm(cval);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        term: termId,
        pickup_address: "",
        delivery_address: "",
      };
    });
  };

  const handleFocusOut = (e) => {
    let flag = 0;
    let er = { ...errors };

    if (e.target.name === "company_name") {
      if (e.target.value === "") {
        flag = 1;
        er.company_name = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 150) {
        flag = 1;
        er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExp = regExpressions.company_name;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.company_name = "";
        }
      }
    }

    if (e.target.name === "contact_person") {
      if (e.target.value === "") {
        flag = 1;
        er.contact_person = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 50) {
        flag = 1;
        er.contact_person = errorMessages.MAX_LENGTH_50_EXCEEDED;
      } else {
        const regExp = regExpressions.name;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.contact_person = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.contact_person = "";
        }
      }
    }

    if (e.target.name === "email") {
      if (e.target.value === "") {
        flag = 1;
        er.email = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > EMAIL_FIELD_MAX_LENGTH) {
        flag = 1;
        er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const currentEmail = e.target.value.split("@")[1];
        const regExp = regExpressions.email;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else if (IGNORE_EMAILS.includes(currentEmail)) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.email = "";
        }
      }
    }

    if (e.target.name === "phone") {
      let phoneValue = e.target.value.trim();
      let numberWithoutCountryCode = phoneValue
        .replace(/^\+(\d{1,4})\s?/, "")
        .replace(/\s/g, "");
      if (numberWithoutCountryCode === "+") {
        flag = 0;
        er.phone = "";
      }
      if (
        phoneValue !== "" &&
        phoneValue.length > 4 &&
        numberWithoutCountryCode > 0
      ) {
        if (!isValidPhoneNumber(phoneValue)) {
          flag = 1;
          er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
        } else {
          flag = 0;
          er.phone = "";
        }
      }
    }

    if (e.target.name === "country_from") {
      if (e.target.value === "") {
        flag = 1;
        er.country_from = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.country_from = "";
      }
    }

    if (e.target.name === "country_to") {
      if (e.target.value === "") {
        flag = 1;
        er.country_to = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.country_to = "";
      }
    }

    if (e.target.name === "ocean_type") {
      if (e.target.value === "") {
        flag = 1;
        er.ocean_type = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.ocean_type = "";
      }
    }

    if (e.target.name === "no_of_containers") {
      let no = e.target.value;
      let noReg = regExpressions.inquiry.no_of_containers;
      if ((selectedFreightType && selectedFreightType.value == "Road") || (selectedOceanType && (selectedOceanType.value == "FCL" || selectedOceanType.value == "Project_Cargo" || selectedOceanType.value == "DAG_GOODS" || selectedOceanType.value == "LCL_FCL"))) {
        if (e.target.value == "") {
          flag = 1;
          er.no_of_containers = errorMessages.FIELD_REQUIRED;
        } else if (e.target.value !== "" && no.length > 0) {
          if (no.length > 150) {
            flag = 1;
            er.no_of_containers = errorMessages.MAX_LENGTH_150_EXCEEDED;
          } else {
            const check = noReg.test(e.target.value);
            if (check === false) {
              flag = 1;
              er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
            } else {
              flag = 0;
              er.no_of_containers = "";
            }
          }
        }
      }

      if(selectedOceanType && (selectedOceanType.value == "LCL" || selectedOceanType.value == "Ro-Ro" || selectedOceanType.value == "Bulk")) {
        if (e.target.value !== "" && no.length > 0) {
          if (no.length > 150) {
            flag = 1;
            er.no_of_containers = errorMessages.MAX_LENGTH_150_EXCEEDED;
          } else {
            const check = noReg.test(e.target.value);
            if (check === false) {
              flag = 1;
              er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
            } else {
              flag = 0;
              er.no_of_containers = "";
            }
          }
        }
      }

      /*const isBulk = formData.ocean_type === "Bulk";
      const isFCL = formData.ocean_type === "FCL";
      const isRequired = !isBulk;
      let no = e.target.value;
      let noReg = regExpressions.inquiry.no_of_containers;
      if (isFCL && e.target.value === "") {
        flag = 1;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value !== "" && no.length > 0) {
        if (no.length > 20) {
          flag = 1;
          er.no_of_containers = errorMessages.MAX_LENGTH_20_EXCEEDED;
        } else {
          const check = noReg.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.no_of_containers = "";
          }
        }
      } else {
        flag = 0;
        er.no_of_containers = "";
      } */
    }

    if (e.target.name === "lwh") {
      let no = e.target.value;
      let noReg = regExpressions.inquiry.lwh;
      if (e.target.value === "") {
        flag = 1;
        er.lwh = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value !== "" && no.length > 0) {
        if (no.length > 50) {
          flag = 1;
          er.lwh = errorMessages.MAX_LENGTH_50_EXCEEDED;
        } else {
          const check = noReg.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.lwh = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.lwh = "";
          }
        }
      }
    }

    if (e.target.name === "commodity") {
      if (e.target.value === "") {
        flag = 1;
        er.commodity = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > 150) {
        flag = 1;
        er.commodity = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const regExp = regExpressions.inquiry.commodity;

        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.commodity = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.commodity = "";
        }
      }
    }

    if (e.target.name === "hs_code") {
      let hval = e.target.value;
      if (hval != "" && hval.length > 25) {
        flag = 1;
        er.hs_code = errorMessages.MAX_LENGTH_25_EXCEEDED;
      } else {
        flag = 0;
        er.hs_code = "";
      }
    }

    if (e.target.name === "cbpp") {
      const isBulk = formData.ocean_type === "Bulk" || formData.ocean_type == "Project_Cargo";
      const isRequired = !isBulk;
      let no = e.target.value;
      let noReg = regExpressions.inquiry.cbpp;
      if (isRequired && no === "") {
        flag = 1;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value !== "" && no.length > 0) {
        if (no.length > 150) {
          flag = 1;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.cbpp = "";
          }
        }
      }
    }

    if (e.target.name === "total_weight") {
      let no = e.target.value;
      let noReg = regExpressions.inquiry.total_weight;
      if (e.target.value !== "" && no.length > 0) {
        if (no.length > 80) {
          flag = 1;
          er.total_weight = errorMessages.MAX_LENGTH_80_EXCEEDED;
        } else {
          const check = noReg.test(e.target.value);
          if (check === false) {
            flag = 1;
            er.total_weight = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            flag = 0;
            er.total_weight = "";
          }
        }
      }
    }

    if (e.target.name === "term") {
      if (e.target.value === "") {
        flag = 1;
        er.term = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.term = "";
      }
    }

    if (e.target.name === "pickup_address") {
      let pickup_address_len = e.target.value;
      if (
        !isEmpty(formData.term) &&
        showPickupAddress.includes(formData.term)
      ) {
        if (e.target.value === "") {
          flag = 1;
          er.pickup_address = errorMessages.FIELD_REQUIRED;
        } else if (pickup_address_len.length > 255) {
          flag = 1;
          er.pickup_address = errorMessages.MAX_LENGTH_255_EXCEEDED;
        } else {
          flag = 0;
          er.pickup_address = "";
        }
      }
    }

    if (e.target.name === "delivery_address") {
      let delivery_address_len = e.target.value;
      if (
        (!isEmpty(formData.term) &&
        showDeliveryAddress.includes(formData.term) || (selectedFreightType && selectedFreightType.value == "DAP"))
      ) {
        if (e.target.value === "") {
          flag = 1;
          er.delivery_address = errorMessages.FIELD_REQUIRED;
        } else if (delivery_address_len.length > 255) {
          flag = 1;
          er.delivery_address = errorMessages.MAX_LENGTH_255_EXCEEDED;
        } else {
          flag = 0;
          er.delivery_address = "";
        }
      }
    }

    if (e.target.name === "port_of_origin") {
      let error = validatePortInput(e.target.value);
      if (error === null) {
        let port_of_origin_len = e.target.value;
        if ((e.target.value === "" || e.target.value === null) && formData.freight_type != "Road") {
          flag = 1;
          er.port_of_origin = errorMessages.FIELD_REQUIRED;
        } else if (port_of_origin_len.length > 50) {
          flag = 1;
          er.port_of_origin = errorMessages.MAX_LENGTH_50_EXCEEDED;
        } else {
          flag = 0;
          er.port_of_origin = "";
        }
      } else {
        er.port_of_origin = error;
        flag = 0;
      }
    }

    if (e.target.name === "port_of_destination") {
      let error = validatePortInput(e.target.value);
      if (error === null) {
        let port_of_destination_len = e.target.value;
        if ((e.target.value === "" || e.target.value === null) && formData.freight_type != "Road") {
          flag = 1;
          er.port_of_destination = errorMessages.FIELD_REQUIRED;
        } else if (port_of_destination_len.length > 50) {
          flag = 1;
          er.port_of_destination = errorMessages.MAX_LENGTH_50_EXCEEDED;
        } else {
          flag = 0;
          er.port_of_destination = "";
        }
      } else {
        er.port_of_destination = error;
        flag = 0;
      }
    }

    setErrors(er);
    if (flag === 0) {
      setisButtonDisabled(false);
      return false;
    } else {
      return true;
    }
  };

  const handleChange = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleLQPChange = (e, field_name, indx) => {
    console.log("handleLQPChange =======================", field_name);
    const { value } = e.target;

    setFormData((prevData) => {
      const updatedRows = [...(prevData.lwh_qty_packaging || [])];

      updatedRows[indx] = {
        ...updatedRows[indx],
        [field_name]: value,
      };

      return {
        ...prevData,
        lwh_qty_packaging: updatedRows,
      };
    });
  };

  const handleLQPcbppChange = (selectedOption, field_name, indx) => {
    const selectedValue = selectedOption ? selectedOption.value : "";

    setFormData((prevData) => {
      // Deep clone state safely
      const nextData = cloneDeep(prevData);

      if (nextData.lwh_qty_packaging && nextData.lwh_qty_packaging[indx]) {
        nextData.lwh_qty_packaging[indx][field_name] = selectedValue;
      }

      return nextData;
    });
  };

  const handleLQPFocusOut = (indx, field_name) => {
    const targetRow = formData.lwh_qty_packaging[indx];
    let errorMsg = "";

    if (field_name === "lwh") {
      if(!targetRow.lwh || !targetRow.lwh.trim()) {
        errorMsg = errorMessages.FIELD_REQUIRED;
      } else if(size(targetRow.lwh) > 150) {
        errorMsg = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else if(regExpressions.inquiry.lwh && !regExpressions.inquiry.lwh.test(targetRow.lwh)) {
        errorMsg = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if (field_name === "no_qty") {
      if (!targetRow.no_qty || !targetRow.no_qty.trim()) {
        errorMsg = errorMessages.FIELD_REQUIRED;
      } else if (regExpressions.inquiry.no_of_containers && !regExpressions.inquiry.no_of_containers.test(targetRow.no_qty)) {
         errorMsg = errorMessages.IN_VALID_FIELD_FORMAT;
      }
      // else if (isNaN(targetRow.no_qty)) errorMsg = "Must be a number";
    }

    if (field_name === "cbpp" && !targetRow.cbpp) {
      errorMsg = errorMessages.FIELD_REQUIRED;
    }

    setErrors((prevErrors) => {
      const nextErrors = cloneDeep(prevErrors);

      if (!nextErrors.lwh_qty_packaging) nextErrors.lwh_qty_packaging = [];
      if (!nextErrors.lwh_qty_packaging[indx])
        nextErrors.lwh_qty_packaging[indx] = {};

      nextErrors.lwh_qty_packaging[indx][field_name] = errorMsg;

      return nextErrors;
    });
  };

  const handleRecaptchaChange = (value) => {
    setRecapchaValue(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      recaptcha: value ? "" : "Please complete the reCAPTCHA",
    }));
  };

  const handleImgClick = (e, slug) => {
    const map = fileInputsRef.current;
    const inputNode = map.get(slug);

    if (inputNode) {
      inputNode.click(); // Triggers the file selection dialog for this specific input
    }
  };

  const handleFileChange = (e, slug) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!ALLOWED_TYPES.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        [slug]: "Only PDF, JPG, JPEG, PNG, Word Or Excel files are allowed.",
      }));
      e.target.value = "";
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      setErrors((prev) => ({
        ...prev,
        [slug]: "File size must not exceed 2 MB.",
      }));
      e.target.value = "";
      return;
    }

    setErrors((prev) => ({ ...prev, [slug]: "" }));

    // store file directly on formData under its slug key
    setFormData((prev) => ({
      ...prev,
      [slug]: file,
    }));

    setPreviewUrls((prev) => {
      if (prev[slug]) {
        URL.revokeObjectURL(prev[slug]);
      }
      return {
        ...prev,
        [slug]: URL.createObjectURL(file),
      };
    });
  };

  const handleRemoveFile = (e, slug) => {
    e.stopPropagation(); // prevent triggering handleImgClick on the parent

    setPreviewUrls((prev) => {
      if (prev[slug]) {
        URL.revokeObjectURL(prev[slug]);
      }
      const updated = { ...prev };
      delete updated[slug];
      return updated;
    });

    setFormData((prev) => ({
      ...prev,
      [slug]: null,
    }));

    setErrors((prev) => ({ ...prev, [slug]: "" }));

    const inputNode = fileInputsRef.current.get(slug);
    if (inputNode) inputNode.value = ""; // allow re-selecting the same file
  };

  const validateAirFreight = async (er, isValid) => {
    if (!er) er = {};
    er.lwh_qty_packaging = [];

    if (Array.isArray(formData.lwh_qty_packaging)) {
      formData.lwh_qty_packaging.forEach((item, index) => {
        const rowError = {};

        // L/W/H Validation
        let lwhVal = item.lwh ? String(item.lwh).trim() : "";
        if (lwhVal === "") {
          isValid = false;
          rowError.lwh = errorMessages.FIELD_REQUIRED;
        } else if (lwhVal.length > 50) {
          isValid = false;
          rowError.lwh = errorMessages.MAX_LENGTH_50_EXCEEDED;
        } else if (
          regExpressions.inquiry.lwh &&
          !regExpressions.inquiry.lwh.test(lwhVal)
        ) {
          isValid = false;
          rowError.lwh = errorMessages.IN_VALID_FIELD_FORMAT;
        }

        // Quantity Validation
        let qtyVal = item.no_qty ? String(item.no_qty).trim() : "";
        if (qtyVal === "") {
          isValid = false;
          rowError.no_qty = errorMessages.FIELD_REQUIRED;
        } else if (
          regExpressions.inquiry.no_of_containers &&
          !regExpressions.inquiry.no_of_containers.test(qtyVal)
        ) {
          isValid = false;
          rowError.no_qty = errorMessages.IN_VALID_FIELD_FORMAT;
        }

        // Packaging Type Dropdown Validation
        if (!item.cbpp || String(item.cbpp).trim() === "") {
          isValid = false;
          rowError.cbpp = errorMessages.FIELD_REQUIRED;
        }

        er.lwh_qty_packaging[index] = rowError;
      });
    }

    return { er, isValid };
  };

  const validateRoadFreight = (er, isValid) => {
    if (!er) er = {};

    if (formData.no_of_containers == "") {
      isValid = false;
      er.no_of_containers = errorMessages.FIELD_REQUIRED;
    } else if (
      regExpressions.inquiry.no_of_containers &&
      !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
    ) {
      isValid = false;
      er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
    }

    let no2 = formData.cbpp;
    let noReg2 = regExpressions.inquiry.cbpp;
    if (no2 === "") {
      isValid = false;
      er.cbpp = errorMessages.FIELD_REQUIRED;
    } else if (no2 !== "" && no2.length > 0) {
      if (no2.length > 150) {
        isValid = false;
        er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const check = noReg2.test(no2);
        if (check === false) {
          isValid = false;
          er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.cbpp = "";
        }
      }
    } else {
      er.cbpp = "";
    }

    return { er, isValid };
  };

  const validateDAPFreight = (er, isValid) => {
    if (!er) er = {};
    if (formData.ocean_type == "LCL") {
      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;
      if (no2 === "") {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }
    }

    if (formData.ocean_type == "FCL") {
      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }

      let no2 = formData.cbpp;
      console.log("FCL cbpp =========== ", no2)
      let noReg2 = regExpressions.inquiry.cbpp;
      if (no2 === "") {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }
    }

    if(formData.ocean_type == "Ro-Ro") {
      if (formData.no_of_containers != "" && 
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if(formData.ocean_type == "Project_Cargo") {
      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }

      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;

      if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
    } else {
      er.cbpp = "";
    }

    }

    if(formData.ocean_type == "DAG_GOODS") {
      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }

      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;
      if (no2 === "") {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }

    }

    return { er, isValid };
  };

  const validateSeaFreight = (er, isValid) => {
    if (!er) er = {};
    

    if (formData.ocean_type == "LCL") {
      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;
      if (no2 === "") {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }
    }

    if (formData.ocean_type == "FCL") {
      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }

      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;
      console.log("no2 ============== ", no2, " >>>>>>>>>>>>>>>>> typeof no2", typeof no2)
      if (no2 === "" || no2 === null) {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }
    }

    if(formData.ocean_type == "Ro-Ro") {
      if (formData.no_of_containers != "" && 
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if(formData.ocean_type == "Project_Cargo") {

      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }

      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;

      if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
    } else {
      er.cbpp = "";
    }
  }

    if(formData.ocean_type == "DAG_GOODS" || formData.ocean_type == "LCL_FCL") {
      if (formData.no_of_containers == "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (
        regExpressions.inquiry.no_of_containers &&
        !regExpressions.inquiry.no_of_containers.test(formData.no_of_containers)
      ) {
        isValid = false;
        er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
      }

      let no2 = formData.cbpp;
      let noReg2 = regExpressions.inquiry.cbpp;
      if (no2 === "") {
        isValid = false;
        er.cbpp = errorMessages.FIELD_REQUIRED;
      } else if (no2 !== "" && no2.length > 0) {
        if (no2.length > 150) {
          isValid = false;
          er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
        } else {
          const check = noReg2.test(no2);
          if (check === false) {
            isValid = false;
            er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.cbpp = "";
          }
        }
      } else {
        er.cbpp = "";
      }

    }



    return { er, isValid };
  }

  const validation = async () => {
    let er = { ...errors };
    let isValid = true;
    const isBulk = formData.ocean_type === "Bulk";
    const isFCL = formData.ocean_type === "FCL";
    if (!formData.company_name || formData.company_name === "") {
      isValid = false;
      er.company_name = errorMessages.FIELD_REQUIRED;
    } else if (formData.company_name.length > 150) {
      isValid = false;
      er.company_name = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      const regExp = regExpressions.company_name;
      const check = regExp.test(formData.company_name);
      if (check === false) {
        isValid = false;
        er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.company_name = "";
      }
    }

    if (formData.contact_person === "") {
      isValid = false;
      er.contact_person = errorMessages.FIELD_REQUIRED;
    } else if (formData.contact_person.length > 50) {
      isValid = false;
      er.contact_person = errorMessages.MAX_LENGTH_50_EXCEEDED;
    } else {
      const regExp = regExpressions.name;

      const check = regExp.test(formData.contact_person);
      if (check === false) {
        isValid = false;
        er.contact_person = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.contact_person = "";
      }
    }

    if (formData.email === "") {
      isValid = false;
      er.email = errorMessages.FIELD_REQUIRED;
    } else if (formData.email.length > EMAIL_FIELD_MAX_LENGTH) {
      isValid = false;
      er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      const currentEmail = formData.email.split("@")[1];
      const regExp = regExpressions.email;
      const check = regExp.test(formData.email);
      if (check === false) {
        isValid = false;
        er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      } else if (IGNORE_EMAILS.includes(currentEmail)) {
        isValid = false;
        er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.email = "";
      }
    }

    if (phoneValue) {
      let numberWithoutCountryCode = phoneValue.replace(/^\+(\d{1,4})\s?/, "");
      numberWithoutCountryCode = numberWithoutCountryCode.replace(/\s/g, "");
      if (
        !phoneValue ||
        (!isValidPhoneNumber(phoneValue) && numberWithoutCountryCode.length > 0)
      ) {
        isValid = false;
        er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
      }
    }

    
    if (formData.freight_type != "Road") {
      if (formData.country_from === "") {
        isValid = false;
        er.country_from = errorMessages.FIELD_REQUIRED;
      } else {
        er.country_from = "";
      }

      if (formData.port_of_origin === "") {
        isValid = false;
        er.port_of_origin = errorMessages.FIELD_REQUIRED;
      } else if (formData.port_of_origin.length > 50) {
        isValid = false;
        er.port_of_origin = errorMessages.MAX_LENGTH_50_EXCEEDED;
      } else {
        er.port_of_origin = "";
      }

      if (formData.freight_type !== "DAP") {
        if (formData.country_to === "") {
          isValid = false;
          er.country_to = errorMessages.FIELD_REQUIRED;
        } else {
          er.country_to = "";
        }

        if (formData.port_of_destination === "") {
          isValid = false;
          er.port_of_destination = errorMessages.FIELD_REQUIRED;
        } else if (formData.port_of_destination.length > 50) {
          isValid = false;
          er.port_of_destination = errorMessages.MAX_LENGTH_50_EXCEEDED;
        } else {
          er.port_of_destination = "";
        }
      }
    }

    if (formData.freight_type === "") {
      isValid = false;
      er.freight_type = errorMessages.FIELD_REQUIRED;
    } else {
      er.freight_type = "";
    }

    if (!formData.commodity || formData.commodity === "") {
      isValid = false;
      er.commodity = errorMessages.FIELD_REQUIRED;
    } else if (formData.commodity.length > 150) {
      isValid = false;
      er.commodity = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      const regExp = regExpressions.inquiry.commodity;

      const check = regExp.test(formData.commodity);
      if (check === false) {
        isValid = false;
        er.commodity = errorMessages.IN_VALID_FIELD_FORMAT;
      } else {
        er.commodity = "";
      }
    }

    if (formData.hs_code !== "") {
      let hval = formData.hs_code;
      if (hval != "" && hval.length > 25) {
        isValid = false;
        er.hs_code = errorMessages.MAX_LENGTH_25_EXCEEDED;
      } else {
        er.hs_code = "";
      }
    }

    console.log("FFFFFFff", formData.freight_type);
    console.log("ocean_type////////////////// ", formData.ocean_type);

    if (formData.freight_type != "" && formData.freight_type != "Air") {
      console.log("iiiiiiiiiiiiiifffffffffffff");
      if (formData.ocean_type === "" || formData.ocean_type === null) {
        console.log("ooooooooooooooofffffffffffff");
        isValid = false;
        er.ocean_type = errorMessages.FIELD_REQUIRED;
      } else {
        er.ocean_type = "";
      }
    }

    console.log("er ================ ", er);

    /* if (formData.freight_type === "" || formData.freight_type === "Ocean") {
      if (formData.ocean_type === "") {
        isValid = false;
        er.ocean_type = errorMessages.FIELD_REQUIRED;
      } else {
        er.ocean_type = "";
      }

      let no1 = formData.no_of_containers;
      let noReg1 = regExpressions.inquiry.no_of_containers;
      if (isFCL && no1 === "") {
        isValid = false;
        er.no_of_containers = errorMessages.FIELD_REQUIRED;
      } else if (no1 !== "" && no1.length > 0) {
        if (no1.length > 20) {
          isValid = false;
          er.no_of_containers = errorMessages.MAX_LENGTH_20_EXCEEDED;
        } else {
          const check = noReg1.test(no1);
          if (check === false) {
            isValid = false;
            er.no_of_containers = errorMessages.IN_VALID_FIELD_FORMAT;
          } else {
            er.no_of_containers = "";
          }
        }
      } else {
        er.no_of_containers = "";
      }
    } */

    /* let no2 = formData.cbpp;
    let noReg2 = regExpressions.inquiry.cbpp;
    if (!isBulk && no2 === "") {
      isValid = false;
      er.cbpp = errorMessages.FIELD_REQUIRED;
    } else if (no2 !== "" && no2.length > 0) {
      if (no2.length > 150) {
        isValid = false;
        er.cbpp = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const check = noReg2.test(no2);
        if (check === false) {
          isValid = false;
          er.cbpp = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.cbpp = "";
        }
      }
    } else {
      er.cbpp = "";
    } */

    let no3 = formData.total_weight;
    let noReg3 = regExpressions.inquiry.total_weight;
    if (no3 !== "" && no3.length > 0) {
      if (no3.length > 80) {
        isValid = false;
        er.total_weight = errorMessages.MAX_LENGTH_80_EXCEEDED;
      } else {
        const check = noReg3.test(no3);
        if (check === false) {
          isValid = false;
          er.total_weight = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          er.total_weight = "";
        }
      }
    }

    if (formData.freight_type != "Road" && formData.freight_type != "DAP") {
      if (formData.term === "") {
        isValid = false;
        er.term = errorMessages.FIELD_REQUIRED;
      } else {
        er.term = "";
      }
    }

    if (!isEmpty(formData.term) && showPickupAddress.includes(formData.term)) {
      let pickup_address_len = formData.pickup_address;
      if (formData.pickup_address === "") {
        isValid = false;
        er.pickup_address = errorMessages.FIELD_REQUIRED;
      } else if (pickup_address_len.length > 255) {
        isValid = false;
        er.pickup_address = errorMessages.MAX_LENGTH_255_EXCEEDED;
      } else {
        er.pickup_address = "";
      }
    }

    if (
      (!isEmpty(formData.term) &&
        showDeliveryAddress.includes(formData.term)) ||
      (!isEmpty(formData.freight_type) && formData.freight_type == "DAP")
    ) {
      let delivery_address_len = formData.delivery_address;
      if (formData.delivery_address === "") {
        isValid = false;
        er.delivery_address = errorMessages.FIELD_REQUIRED;
      } else if (delivery_address_len.length > 255) {
        isValid = false;
        er.delivery_address = errorMessages.MAX_LENGTH_255_EXCEEDED;
      } else {
        er.delivery_address = "";
      }
    }

    if (recaptchaValue === null) {
      isValid = false;
      er.recaptcha = "Please verify the reCAPTCHA!";
    } else {
      er.recaptcha = "";
    }

    if (formData.freight_type === "" || formData.freight_type === "Air") {
      let res = await validateAirFreight(er, isValid);
      console.log("res ======================== ", res);
      er = res.er;
      isValid = res.isValid;
    }

    if (formData.freight_type === "Road") {
      let res = await validateRoadFreight(er, isValid);
      er = res.er;
      isValid = res.isValid;
    }

    if (formData.freight_type === "DAP") {
      let res = await validateDAPFreight(er, isValid);
      er = res.er;
      isValid = res.isValid;
    }

    if (formData.freight_type === "Ocean") {
      let res = await validateSeaFreight(er, isValid);
      er = res.er;
      isValid = res.isValid;
    }

    console.log("outside er ======================== ", er);

    setErrors(er);
    // if (flag === 1) {
    //   return false;
    // } else {
    //   return true;
    // }
    if (!isValid) {
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (await validation()) {
      try {
        setisButtonDisabled(true);
        setLoading(true);

        const payload = new FormData();

        Object.entries(formData).forEach(([key, value]) => {
          if (value === null || value === undefined) return;

          if (key === "lwh_qty_packaging") {
            payload.append(key, JSON.stringify(value));
          } else if (value instanceof File) {
            payload.append(key, value);
          } else if (typeof value === "object") {
            payload.append(key, JSON.stringify(value));
          } else {
            payload.append(key, value);
          }
        });

        console.log(" ========== payload ======== ", payload);

        const response = await dispatch(postInquiryQuote(payload));

        if (response && response.meta.requestStatus === "fulfilled") {
          if (response.payload.status === true) {
            setLoading(false);
            showSuccessMessage("The inquiry has been submitted successfully.");

            const initialState0 = {
              company_name: user ? user.company_name : "",
              contact_person: user ? user.name : "",
              email: user ? user.email : "",
              phone: "",
              message: "",
              country_from: "",
              country_from_id: "",
              country_to: "",
              country_to_id: "",
              freight_type: "",
              port_of_destination: "",
              port_of_origin: "",
              ocean_type: "",
              lwh: "",
              cbpp: "",
              total_weight: "",
              term: "",
              pickup_address: "",
              delivery_address: "",
              no_of_containers: "",
              type: "Logistic_Partner",
              commodity: "",
              hs_code: "",
              inquiry_type: "GLOBAL",
              created_by: user ? user.id : null,
              lwh_qty_packaging: [
                {
                  lwh: " ",
                  no_qty: " ",
                  cbpp: " ",
                },
              ],
            };
            //setPortOfOriginList([]);
            setSelectedPortOfOrigin(null);
            //setPortOfDestinationList([]);
            setSelectedPortOfDestination(null);
            setFormData(initialState0);
            setErrors({});
            setphoneValue("");
            setSelectedCountryFrom(null);
            setSelectedCountryTo(null);
            setSelectedFreightType(null);
            setSelectedOceanType(null);
            setSelectedTerm(null);
            setisButtonDisabled(false);
            
            Object.values(previewUrls).forEach((p) => {
              if (p?.path) URL.revokeObjectURL(p.path);
            });

            setPreviewUrls({});

            setTimeout(() => {
              recaptcha.current.reset();
              // setMessage("");
              setLoading(false);
            }, 3000);

            setRecapchaValue(null);
          }
          if (response.payload.errors) {
            setisButtonDisabled(false);
            setLoading(false);
            setErrors([]);
            const errors = {};
            if (response.payload.errors.company_name) {
              errors.company_name = response.payload.errors.company_name;
            }
            if (response.payload.errors.contact_person) {
              errors.contact_person = response.payload.errors.contact_person;
            }
            if (response.payload.errors.email) {
              errors.email = response.payload.errors.email;
            }
            if (response.payload.errors.country) {
              errors.country = response.payload.errors.country;
            }
            if (response.payload.errors.industry) {
              errors.industry = response.payload.errors.industry;
            }
            if (response.payload.errors.product) {
              errors.product = response.payload.errors.product;
            }

            if (response.payload.errors.quantity) {
              errors.quantity = response.payload.errors.quantity;
            }

            if (response.payload.errors.unit) {
              errors.unit = response.payload.errors.unit;
            }

            if (response.payload.errors.cbpp) {
              errors.cbpp = response.payload.errors.cbpp;
            }

            if (response.payload.errors.country_from) {
              errors.country_from = response.payload.errors.country_from;
            }
            if (response.payload.errors.country_to) {
              errors.country_to = response.payload.errors.country_to;
            }

            if (response.payload.errors.freight_type) {
              errors.freight_type = response.payload.errors.freight_type;
            }
            if (response.payload.errors.port_of_destination) {
              errors.port_of_destination =
                response.payload.errors.port_of_destination;
            }
            if (response.payload.errors.port_of_origin) {
              errors.port_of_origin = response.payload.errors.port_of_origin;
            }
            if (response.payload.errors.commodity) {
              errors.commodity = response.payload.errors.commodity;
            }
            if (response.payload.errors.term) {
              errors.term = response.payload.errors.term;
            }
            if (response.payload.errors.pickup_address) {
              errors.pickup_address = errorMessages.FIELD_REQUIRED;
            }
            if (response.payload.errors.delivery_address) {
              errors.delivery_address = errorMessages.FIELD_REQUIRED;
            }

            if (response.payload.errors.lwh) {
              errors.lwh = response.payload.errors.lwh;
            }

            if (response.payload.errors.ocean_type) {
              errors.ocean_type = response.payload.errors.ocean_type;
            }
            if (response.payload.errors.no_of_containers) {
              errors.no_of_containers =
                response.payload.errors.no_of_containers;
            }
            setErrors(errors);
          }
        }
      } catch (err) {
        setLoading(false);
        console.error(err);
      }
    }
  };

  const styleError = { display: "block" };

  console.log("Errors =============== ", errors);

  return (
    <>
      {isLoading && <ScreenLoaderHome />}
      <section className="form-wrape">
        <div className="section-head">
          <h1 className="">Submit Your Requirement</h1>
          <p>
            Easily submit your requirements and connect with verified Logistic
            Partners worldwide.
          </p>
        </div>

        <div className="form-pad">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-sm-12 mb-3 inquiry-info-labal">
                <h2 className="head">Contact Information</h2>
              </div>

              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div
                  className={`input-wrape ${errors.company_name ? "error-show" : ""}`}
                >
                  <div className="input-pad">
                    <input
                      type="text"
                      name="company_name"
                      value={formData.company_name}
                      className="input"
                      autoComplete="off"
                      placeholder="Enter company name *"
                      onChange={handleChange}
                      onBlur={handleFocusOut}
                      disabled={user && user.company_name}
                    />
                    {errors.company_name && (
                      <span className="invalid-feedback" style={styleError}>
                        {errors.company_name}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div
                  className={`input-wrape ${errors.contact_person ? "error-show" : ""}`}
                >
                  <div className="input-pad">
                    <input
                      type="text"
                      name="contact_person"
                      value={formData.contact_person}
                      className="input"
                      autoComplete="off"
                      placeholder="Enter contact person *"
                      onChange={handleChange}
                      onBlur={handleFocusOut}
                      disabled={user && user.name}
                    />
                    {errors.contact_person && (
                      <span className="invalid-feedback" style={styleError}>
                        {errors.contact_person}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div
                  className={`input-wrape ${errors.email ? "error-show" : ""}`}
                >
                  <div className="input-pad">
                    <input
                      type="text"
                      name="email"
                      className="input"
                      value={formData.email}
                      autoComplete="off"
                      placeholder="Enter your email *"
                      onChange={handleChange}
                      onBlur={handleFocusOut}
                      disabled={user && user.email}
                    />
                    {errors.email && (
                      <span className="invalid-feedback" style={styleError}>
                        {errors.email}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div
                  className={`input-wrape ${errors.phone ? "error-show" : ""}`}
                >
                  <div className="input-pad">
                    <PhoneInput
                      id="contact-form-phone"
                      className="input"
                      name="phone"
                      international
                      limitMaxLength
                      placeholder="Enter phone number"
                      autoComplete="off"
                      value={phoneValue}
                      onChange={handlePhoneChange}
                      onBlur={handleFocusOut}
                    />
                    {errors.phone && (
                      <span className="invalid-feedback" style={styleError}>
                        {errors.phone}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-xxl-12">
                <div className="col-sm-12 mb-3 inquiry-info-labal">
                  <h2 className="head">Inquiry Information</h2>
                </div>

                <div id="logistic_partner" className="row">
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12">
                    <div
                      className={`input-wrape select-wrape ${errors.freight_type ? "error-show" : ""}`}
                      style={{ zIndex: "12" }}
                    >
                      <div className="input-pad select-wrape">
                        <Select
                          name="freight_type"
                          options={FREIGHT_TYPE}
                          value={selectedFreightType}
                          onChange={handleFreightTypeChange}
                          placeholder="Select freight type *"
                          className="select"
                          noOptionsMessage={() => "No Freight Type Found"}
                          onBlur={handleFocusOut}
                          classNamePrefix={"Drop-down-menu"}
                        />
                        {errors.freight_type && (
                          <span className="invalid-feedback" style={styleError}>
                            {errors.freight_type}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                  {(isEmpty(selectedFreightType) ||
                    (selectedFreightType &&
                      selectedFreightType.value == "Air")) && (
                    <AirFreight
                      errors={errors}
                      styleError={styleError}
                      formData={formData}
                      handleFocusOut={handleFocusOut}
                      handleCountryFromChange={handleCountryFromChange}
                      handleCountryToChange={handleCountryToChange}
                      handleTermChange={handleTermChange}
                      handleChange={handleChange}
                      showPickupAddress={showPickupAddress}
                      showDeliveryAddress={showDeliveryAddress}
                      countries={countries}
                      selectedTerm={selectedTerm}
                      selectedCountryFrom={selectedCountryFrom}
                      selectedCountryTo={selectedCountryTo}
                      handleAddClick={handleAddClick}
                      handleRemoveClick={handleRemoveClick}
                      handleLQPChange={handleLQPChange}
                      handleLQPcbppChange={handleLQPcbppChange}
                      handleLQPFocusOut={handleLQPFocusOut}
                    />
                  )}

                  {!isEmpty(selectedFreightType) &&
                    selectedFreightType.value == "Road" && (
                      <RoadFreight
                        errors={errors}
                        styleError={styleError}
                        formData={formData}
                        handleFocusOut={handleFocusOut}
                        handleCountryFromChange={handleCountryFromChange}
                        handleCountryToChange={handleCountryToChange}
                        handleTermChange={handleTermChange}
                        handleChange={handleChange}
                        showPickupAddress={showPickupAddress}
                        showDeliveryAddress={showDeliveryAddress}
                        countries={countries}
                        selectedTerm={selectedTerm}
                        selectedCountryFrom={selectedCountryFrom}
                        selectedCountryTo={selectedCountryTo}
                        handlePortOfOriginChange={handlePortOfOriginChange}
                        handleOriginPortInputChange={
                          handleOriginPortInputChange
                        }
                        portOfOriginList={portOfOriginList}
                        selectedPortOfOrigin={selectedPortOfOrigin}
                        originLoader={originLoader}
                        handlePortOfDestinationChange={
                          handlePortOfDestinationChange
                        }
                        handleDestinationPortInputChange={
                          handleDestinationPortInputChange
                        }
                        portOfDestinationList={portOfDestinationList}
                        selectedPortOfDestination={selectedPortOfDestination}
                        destinationLoader={destinationLoader}
                        validatePortInput={validatePortInput}
                        selectedOceanType={selectedOceanType}
                        handleOceanTypeChange={handleOceanTypeChange}
                      />
                    )}

                  {!isEmpty(selectedFreightType) &&
                    selectedFreightType.value == "DAP" && (
                      <DAPFreight
                        errors={errors}
                        styleError={styleError}
                        formData={formData}
                        handleFocusOut={handleFocusOut}
                        handleCountryFromChange={handleCountryFromChange}
                        handleCountryToChange={handleCountryToChange}
                        handleChange={handleChange}
                        countries={countries}
                        selectedCountryFrom={selectedCountryFrom}
                        selectedCountryTo={selectedCountryTo}
                        handlePortOfOriginChange={handlePortOfOriginChange}
                        handleOriginPortInputChange={handleOriginPortInputChange}
                        portOfOriginList={portOfOriginList}
                        selectedPortOfOrigin={selectedPortOfOrigin}
                        originLoader={originLoader}
                        handlePortOfDestinationChange={
                          handlePortOfDestinationChange
                        }
                        handleDestinationPortInputChange={
                          handleDestinationPortInputChange
                        }
                        portOfDestinationList={portOfDestinationList}
                        selectedPortOfDestination={selectedPortOfDestination}
                        destinationLoader={destinationLoader}
                        validatePortInput={validatePortInput}
                        selectedOceanType={selectedOceanType}
                        handleOceanTypeChange={handleOceanTypeChange}
                        handleCbppTypeChange={handleCbppTypeChange}
                        selectedCbpp={selectedCbpp}
                      />
                    )}

                  {
                    !isEmpty(selectedFreightType) && selectedFreightType.value == "Ocean" && (
                      <SeaFreight 
                        errors={errors}
                        styleError={styleError}
                        formData={formData}
                        handleFocusOut={handleFocusOut}
                        handleCountryFromChange={handleCountryFromChange}
                        handleCountryToChange={handleCountryToChange}
                        handleTermChange={handleTermChange}
                        handleChange={handleChange}
                        showPickupAddress={showPickupAddress}
                        showDeliveryAddress={showDeliveryAddress}
                        countries={countries}
                        selectedTerm={selectedTerm}
                        selectedCountryFrom={selectedCountryFrom}
                        selectedCountryTo={selectedCountryTo}
                        handlePortOfOriginChange={handlePortOfOriginChange}
                        handleOriginPortInputChange={
                          handleOriginPortInputChange
                        }
                        portOfOriginList={portOfOriginList}
                        selectedPortOfOrigin={selectedPortOfOrigin}
                        originLoader={originLoader}
                        handlePortOfDestinationChange={
                          handlePortOfDestinationChange
                        }
                        handleDestinationPortInputChange={
                          handleDestinationPortInputChange
                        }
                        portOfDestinationList={portOfDestinationList}
                        selectedPortOfDestination={selectedPortOfDestination}
                        destinationLoader={destinationLoader}
                        validatePortInput={validatePortInput}
                        selectedOceanType={selectedOceanType}
                        handleOceanTypeChange={handleOceanTypeChange}
                        handleCbppTypeChange={handleCbppTypeChange}
                        selectedCbpp={selectedCbpp}

                      />
                    )
                  }

                  {/* <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12"></div>

                <div className="col-xxl-12" ><hr className="mt-0" /></div> */}

                  {/* <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape select-wrape ${errors.country_from ? 'error-show' : ''}`} style={{ "zIndex": "11" }}>
                    <div className="input-pad select-wrape">
                      <Select
                        name="country_from"
                        options={countries}
                        value={selectedCountryFrom}
                        onChange={handleCountryFromChange}
                        placeholder="Select country *"
                        className="select"
                        onBlur={handleFocusOut}
                        noOptionsMessage={() => "No Country Found"}
                        classNamePrefix={"Drop-down-menu"}
                      />
                      {errors.country_from && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.country_from}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape ${errors.port_of_origin ? 'error-show' : ''}`} style={{ "zIndex": "10" }}>
                    <div className="input-pad">
                      {selectedFreightType && selectedFreightType.value === 'Air' ?
                        <input
                          type="text"
                          name="port_of_origin"
                          value={formData.port_of_origin}
                          className="input"
                          autoComplete="off"
                          placeholder={`Enter ${lowerCase(portLabel)} of origin`}
                          onChange={handleChange}
                          onBlur={handleFocusOut}
                        />
                        :
                        <CreatableSelect
                          name="port_of_origin"
                          onChange={handlePortOfOriginChange}
                          onInputChange={handleOriginPortInputChange}
                          options={portOfOriginList}
                          value={selectedPortOfOrigin}
                          classNamePrefix={"creatable_react_select Drop-down-menu"}
                          placeholder={`Enter ${lowerCase(portLabel)} of origin`}
                          formatCreateLabel={(inputValue) => {
                            const validationError = validatePortInput(inputValue);
                            if (
                              validationError ||
                              validatePortInput(inputValue) ||
                              isEmpty(inputValue)
                            ) {
                              return;
                            }
                            return `Create "${inputValue}"`;
                          }}
                          isValidNewOption={(inputValue) => {
                            const validationError = validatePortInput(inputValue);
                            return validationError === null;
                          }}
                          isLoading={originLoader}
                        />
                      }
                      {/* <input
                                                      type="text"
                                                      name="port_of_origin"
                                                      value={formData.port_of_origin}
                                                      className="form-control"
                                                      autoComplete="off"
                                                      placeholder="Enter port of origin"
                                                      onChange={handleChange}
                                                      onBlur={handleFocusOut}
                                                    /> */}

                  {/* errors.port_of_origin && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.port_of_origin}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape select-wrape ${errors.country_to ? 'error-show' : ''}`} style={{ "zIndex": "9" }}>
                    <div className="input-pad select-wrape">
                      <Select
                        name="country_to"
                        options={countries}
                        value={selectedCountryTo}
                        onChange={handleCountryToChange}
                        placeholder="Select country *"
                        className="select"
                        noOptionsMessage={() => "No Country Found"}
                        onBlur={handleFocusOut}
                        classNamePrefix={"Drop-down-menu"}
                      />
                      {errors.country_to && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.country_to}
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape select-wrape ${errors.port_of_destination ? 'error-show' : ''}`} style={{ "zIndex": "8" }}>
                    <div className="input-pad">
                      {selectedFreightType && selectedFreightType.value === 'Air' ? <input
                        type="text"
                        name="port_of_destination"
                        value={formData.port_of_destination}
                        className="input"
                        autoComplete="off"
                        placeholder={`Enter ${lowerCase(portLabel)} of destination *`}
                        onChange={handleChange}
                        onBlur={handleFocusOut}
                      /> : <CreatableSelect
                        name="port_of_destination"
                        onChange={handlePortOfDestinationChange}
                        onInputChange={handleDestinationPortInputChange}
                        options={portOfDestinationList}
                        value={selectedPortOfDestination}
                        classNamePrefix={"creatable_react_select Drop-down-menu"}
                        placeholder={`Enter ${lowerCase(portLabel)} of destination *`}
                        formatCreateLabel={(inputValue) => {
                          const validationError = validatePortInput(inputValue);
                          if (
                            validationError ||
                            validatePortInput(inputValue) ||
                            isEmpty(inputValue)
                          ) {
                            return;
                          }
                          return `Create "${inputValue}"`;
                        }}
                        isValidNewOption={(inputValue) => {
                          const validationError = validatePortInput(inputValue);
                          return validationError === null;
                        }}
                        isLoading={destinationLoader}
                      />}
                      {/* <input
                                                      type="text"
                                                      name="port_of_destination"
                                                      value={formData.port_of_destination}
                                                      className="form-control"
                                                      autoComplete="off"
                                                      placeholder="Enter port of destination"
                                                      onChange={handleChange}
                                                      onBlur={handleFocusOut}
                                                    /> */}

                  {/*errors.port_of_destination && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.port_of_destination}
                        </span>
                      )}
                    </div>
                  </div>
                </div> */}

                  {/* {selectedFreightType && selectedFreightType.value === 'Ocean' ? (
                  <>
                    <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6">
                      <div className={`input-wrape select-wrape ${errors.ocean_type ? 'error-show' : ''}`} style={{ "zIndex": "7" }}>
                        <div className="input-pad select-wrape">
                          <Select
                            name="ocean_type"
                            options={OCEAN_TYPE}
                            value={selectedOceanType}
                            onChange={handleOceanTypeChange}
                            placeholder="Select ocean type *"
                            className="select"
                            noOptionsMessage={() => "No Ocean Type Found"}
                            onBlur={handleFocusOut}
                            classNamePrefix={"Drop-down-menu"}
                          />
                          {errors.ocean_type && (
                            <span
                              className="invalid-feedback"
                              style={styleError}
                            >
                              {errors.ocean_type}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-xxl-3 col-xl-3 col-lg-6 col-md-6 col-sm-6">
                      <div className={`input-wrape ${errors.no_of_containers ? 'error-show' : ''}`}>
                        <div className="input-pad">
                          <input
                            type="text"
                            name="no_of_containers"
                            value={formData.no_of_containers}
                            className="input"
                            autoComplete="off"
                            placeholder={selectedOceanType?.value === 'FCL' ? 'No. of Containers *' : 'No. of Containers'}
                            onChange={handleChange}
                            onBlur={handleFocusOut}
                          />
                          {errors.no_of_containers && (
                            <span
                              className="invalid-feedback"
                              style={styleError}
                            >
                              {errors.no_of_containers}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (

                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                    <div className={`input-wrape ${errors.lwh ? 'error-show' : ''}`}>
                      <div className="input-pad ">
                        <input
                          type="text"
                          name="lwh"
                          value={formData.lwh}
                          className="input"
                          autoComplete="off"
                          placeholder="Enter Length/Width/Height (CM) *"
                          onChange={handleChange}
                          onBlur={handleFocusOut}
                        />
                        {errors.lwh && (
                          <span
                            className="invalid-feedback"
                            style={styleError}
                          >
                            {errors.lwh}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>

                )} */}

                  {/* <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape ${errors.commodity ? 'error-show' : ''}`}>
                    <div className="input-pad">
                      <input
                        type="text"
                        name="commodity"
                        value={formData.commodity}
                        className="input"
                        autoComplete="off"
                        placeholder="Enter commodity *"
                        onChange={handleChange}
                        onBlur={handleFocusOut}

                      />
                      {errors.commodity && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.commodity}
                        </span>
                      )}
                    </div>
                  </div>
                </div> */}

                  {/* <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape ${errors.cbpp ? 'error-show' : ''}`}>
                    <div className="input-pad">
                      <input
                        type="text"
                        name="cbpp"
                        value={formData.cbpp}
                        className="input"
                        autoComplete="off"
                        placeholder={selectedOceanType?.value !== 'Bulk' ? 'Enter containers Type/Boxes/Pallat/Packages *' : 'Enter containers Type/Boxes/Pallat/Packages'}
                        onChange={handleChange}
                        onBlur={handleFocusOut}
                      />
                      {errors.cbpp && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.cbpp}
                        </span>
                      )}
                    </div>
                  </div>
                </div> */}

                  {/* <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape ${errors.total_weight ? 'error-show' : ''}`}>
                    <div className="input-pad">
                      <input
                        type="text"
                        name="total_weight"
                        value={formData.total_weight}
                        className="input"
                        autoComplete="off"
                        placeholder="Enter total weight (kg)"
                        onChange={handleChange}
                        onBlur={handleFocusOut}
                      />
                      {errors.total_weight && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.total_weight}
                        </span>
                      )}
                    </div>
                  </div>
                </div> */}

                  {/* <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div className={`input-wrape select-wrape ${errors.term ? 'error-show' : ''}`} style={{ "zIndex": "4" }}>
                    <div className="input-pad select-wrape">
                      <Select
                        name="term"
                        options={TERM_LIST}
                        value={selectedTerm}
                        onChange={handleTermChange}
                        classNamePrefix={"Drop-down-menu"}
                        placeholder="Select term type *"
                        className="select"
                        noOptionsMessage={() => "No Term Found"}
                        onBlur={handleFocusOut}
                      />

                      {errors.term && (
                        <span
                          className="invalid-feedback"
                          style={styleError}
                        >
                          {errors.term}
                        </span>
                      )}

                    </div>
                  </div>
                </div> */}

                  {/* {selectedTerm && !isEmpty(selectedTerm) && showPickupAddress.includes(selectedTerm.value) &&
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                    <div className={`input-wrape ${errors.pickup_address ? 'error-show' : ''}`}>
                      <div className="input-pad">
                        <input
                          type="text"
                          name="pickup_address"
                          value={formData.pickup_address}
                          className="input"
                          autoComplete="off"
                          placeholder="Enter pickup address *"
                          onChange={handleChange}
                          onBlur={handleFocusOut}
                        />
                        {errors.pickup_address && (
                          <span
                            className="invalid-feedback"
                            style={styleError}
                          >
                            {errors.pickup_address}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                }
                {selectedTerm && !isEmpty(selectedTerm) && showDeliveryAddress.includes(selectedTerm.value) &&
                  <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                    <div className={`input-wrape ${errors.delivery_address ? 'error-show' : ''}`}>
                      <div className="input-pad">
                        <input
                          type="text"
                          name="delivery_address"
                          value={formData.delivery_address}
                          className="input"
                          autoComplete="off"
                          placeholder="Enter delivery address"
                          onChange={handleChange}
                          onBlur={handleFocusOut}
                        />
                        {errors.delivery_address && (
                          <span
                            className="invalid-feedback"
                            style={styleError}
                          >
                            {errors.delivery_address}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                } */}
                </div>
              </div>

              <div className="col-xxl-12">
                <div
                  className={`input-wrape ${errors.message ? "error-show" : ""}`}
                >
                  <div className="input-pad inquiry-ck-editer">
                    <CKEditor
                      editor={ClassicEditor}
                      data={formData.message || ""}
                      config={{
                        toolbar: {
                          items: [
                            "bold",
                            "italic",
                            "underline",
                            "fontSize",
                            "bulletedList",
                          ],
                        },
                        fontSize: {
                          options: [10, 12, 14, "default", 18, 20, 22, 24, 30],
                          supportAllValues: false,
                        },
                        language: "en",
                        plugins: [
                          Essentials,
                          Bold,
                          Italic,
                          Underline,
                          FontSize,
                          Paragraph,
                          List,
                        ],
                        licenseKey: "GPL",
                        // licenseKey: "",
                      }}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        setFormData((prev) => ({
                          ...prev,
                          message: data,
                        }));
                      }}
                      onReady={(editor) => {
                        editor.editing.view.change((writer) => {
                          writer.setStyle(
                            "height",
                            "150px",
                            editor.editing.view.document.getRoot(),
                          );
                          writer.setStyle(
                            "width",
                            "100",
                            editor.editing.view.document.getRoot(),
                          );
                        });
                      }}
                    />
                    {errors.message && (
                      <span className="invalid-feedback" style={styleError}>
                        {errors.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {map(FILE_SLOTS, (slug) => {
                const file = formData[slug];
                const previewUrl = previewUrls[slug];
                const isImage =
                  file && file.type && file.type.startsWith("image/");
                const isPDF =
                  file && file.type && file.type === "application/pdf";
                const isWord =
                  file &&
                  file.type &&
                  (file.type === "application/msword" ||
                    file.type ===
                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document");
                const isExcel =
                  file &&
                  file.type &&
                  (file.type === "application/vnd.ms-excel" ||
                    file.type ===
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
                    file.type === "text/csv");

                return (
                  <div
                    className="col-xxl-6 col-xl-6 col-lg-6 mb-4"
                    key={`attachment_${slug}`}
                  >
                    <div className="">
                      <input
                        type="file"
                        ref={(node) => {
                          const map = fileInputsRef.current;
                          if (node) {
                            map.set(slug, node);
                          } else {
                            map.delete(slug);
                          }
                        }}
                        autoComplete="off"
                        accept="image/jpeg, image/jpg, image/png, image/webp,
                          application/pdf,
                          application/msword,
                          application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                          application/vnd.ms-excel,
                          application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                          text/csv,
                          .doc, .docx, .xls, .xlsx, .csv"
                        onChange={(e) => handleFileChange(e, slug)}
                        style={{ display: "none" }}
                      />
                      <div
                        className="attachment-box row align-items-center"
                        onClick={(e) => handleImgClick(e, slug)}
                      >
                        <div className="col-xl-2 col-lg-2 col-md-2 col-2 d-flex justify-content-center attachment-image-col">
                          {!previewUrl && (
                            <img
                              src={attachmentImg}
                              alt="main-product-image"
                              className="attachment-upload-img"
                              // onClick={(e) => handleImgClick(e, slug)}
                            />
                          )}

                          {previewUrl && isImage && (
                            <div className="attachment-img-box">
                              <img
                                src={previewUrl}
                                alt="main-product-image"
                                className="attachment-upload-img"
                                // onClick={(e) => handleImgClick(e, slug)}
                              />
                            </div>
                          )}

                          {previewUrl && isPDF && (
                            <div className="attachment-img-box">
                              <img
                                src={pdfsvgImg}
                                alt="main-product-image"
                                className="attachment-upload-img"
                                // onClick={(e) => handleImgClick(e, slug)}
                              />
                            </div>
                          )}

                          {previewUrl && isWord && (
                            <div className="attachment-img-box">
                              <img
                                src={wordImg}
                                alt="main-product-image"
                                className="attachment-upload-img"
                                // onClick={(e) => handleImgClick(e, slug)}
                              />
                            </div>
                          )}

                          {previewUrl && isExcel && (
                            <div className="attachment-img-box">
                              <img
                                src={excelImg}
                                alt="main-product-image"
                                className="attachment-upload-img"
                                onClick={(e) => handleImgClick(e, slug)}
                              />
                            </div>
                          )}
                        </div>
                        <div className="attachment-content col-xl-10 col-lg-10 col-md-10 col-10">
                          {!previewUrl && (
                            <>
                              <h6>Upload Attachment</h6>
                              <p>Allowed PDF, JPEG, JPG, PNG, Word & Excel</p>
                            </>
                          )}

                          {previewUrl && (
                            <>
                              <h6>{file?.name}</h6>

                              <div
                                onClick={(e) => handleRemoveFile(e, slug)}
                                className="delete-icon"
                              >
                                <svg
                                  width="20"
                                  height="20"
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4 7H20"
                                    stroke="#DC3545"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                  />
                                  <path
                                    d="M9 7V4H15V7"
                                    stroke="#DC3545"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M6 7L7 20H17L18 7"
                                    stroke="#DC3545"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M10 11V16M14 11V16"
                                    stroke="#DC3545"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                  />
                                </svg>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    {errors && errors[slug] && (
                      <span className="invalid-feedback" style={styleError}>
                        {errors[slug]}
                      </span>
                    )}
                  </div>
                );
              })}

              <div className="col-xxl-8 col-xl-7 col-lg-8">
                <div className="captcha-wrapes ">
                  <ReCAPTCHA
                    sitekey={process.env.REACT_APP_SITE_KEY}
                    onChange={handleRecaptchaChange}
                    ref={recaptcha}
                    className="Inquiry-capcha"
                    onExpired={() => {
                      setRecapchaValue(null);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        recaptcha: "Please complete the CAPTCHA",
                      }));
                    }}
                  />
                  {errors.recaptcha && (
                    <div className="invalid-feedback" style={styleError}>
                      {errors.recaptcha}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-xxl-4 col-xl-5 col-lg-4 inquiry-form-btn">
                <Button
                  className="btn secondry-btn"
                  type="submit"
                  disabled={isButtonDisabled}
                >
                  Send Inquiry
                </Button>
              </div>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default LogisticInqForm;
